import { PointerSensor as LibPointerSensor } from '@dnd-kit/core';

const shouldHandleEvent = ({ nativeEvent: event }) => {
  const targetElement = event.target;
  const headerClasses = ['unit-header', 'left-header', 'right-header'];
  const targetElementClasses = targetElement?.className;

  // Так как у объекта SVG по ключу className находится объект, метод массивов includes вызывает ошибку
  const isSVG = !!targetElement.closest('svg');
  const isValidHeaderClass =
    !isSVG &&
    targetElementClasses &&
    headerClasses.some((classElement) => targetElementClasses.includes(classElement));

  return isValidHeaderClass;
};

export default class PointerSensor extends LibPointerSensor {
  static activators = [
    {
      eventName: 'onPointerDown',
      handler: shouldHandleEvent,
    },
  ];
}
